import { LarvaUnitObjectsMap } from 'smartHome/larva/types/LarvaUnitObject';
import { UINodeLocal } from 'smartHome/larva/types/UINodeLocal';
import sortAndFilterUINodes from 'smartHome/larva/utils/sortAndFilterUINodes';

const byRatingDesc = (nodeA: UINodeLocal, nodeB: UINodeLocal): number =>
    parseInt(nodeA.ui.rating) > parseInt(nodeB.ui.rating) ? -1 : 1;

export const isLarvaDoorNode = (node: UINodeLocal): boolean => /door/i.test(node?.node?.type || '');

export const collectUnitUiNodes = (unitMap: LarvaUnitObjectsMap | null | undefined): UINodeLocal[] => {
    if (!unitMap) return [];

    return Object.values(unitMap).flatMap((unit) =>
        Object.values(unit?.devices || {}).flatMap((device) => device?.uiNodes || []),
    );
};

export const pickDashboardUiNodes = (nodes: UINodeLocal[] | null | undefined): UINodeLocal[] => {
    const visibleNodes = sortAndFilterUINodes(nodes || []);
    const favoriteNodes = visibleNodes.filter((node) => node.ui.favorite).sort(byRatingDesc);

    if (favoriteNodes.length) return favoriteNodes;

    return visibleNodes.filter(isLarvaDoorNode).sort(byRatingDesc);
};
